var $ecd80835333d83cc$exports = {};
$ecd80835333d83cc$exports = {
  "alert": `\u{8B66}\u{62A5}`,
  "dismiss": `\u{53D6}\u{6D88}`
};
export { $ecd80835333d83cc$exports as default };